module.exports = __webpack_public_path__ + "static/media/banner.37508eaa.png";